import { createAction, createAsyncAction } from 'eight.js.ui-common';

export const loginAsync = createAsyncAction('@@auth/LOGIN');
export const logout = createAction('@@auth/LOGOUT');
export const refreshAsync = createAsyncAction('@@auth/REFRESH');
